import {SummaryLabel, SummaryProgress} from '../my-objective/my-goals-v2.styles';
import {ProgressRing} from '../my-objective/progress-ring';
import {
  AlignmentBar,
  AlignmentBarSegment,
  AlignmentLegend,
  AlignmentOverviewPanel,
  AlignmentSummary,
} from './alignment.styles';

export const AlignmentOverview = ({
  averageProgress,
  alignedCount,
  unalignedCount,
  pageLabel,
}: {
  averageProgress: number;
  alignedCount: number;
  unalignedCount: number;
  pageLabel: string;
}) => {
  const total = alignedCount + unalignedCount;
  const alignedWidth = total ? (alignedCount / total) * 100 : 0;
  const unalignedWidth = total ? (unalignedCount / total) * 100 : 0;

  return (
    <AlignmentOverviewPanel aria-label={`${pageLabel} alignment summary`}>
      <SummaryProgress>
        <ProgressRing progress={averageProgress} />
        <SummaryLabel>
          Avg. progress
          <strong>
            {total} goal{total === 1 ? '' : 's'}
          </strong>
        </SummaryLabel>
      </SummaryProgress>

      <AlignmentSummary>
        <h2>Alignment</h2>
        <AlignmentBar
          aria-label={`${alignedCount} aligned, ${unalignedCount} unaligned`}>
          <AlignmentBarSegment $tone="aligned" $width={alignedWidth} />
          <AlignmentBarSegment $tone="unaligned" $width={unalignedWidth} />
        </AlignmentBar>
        <AlignmentLegend>
          <span data-tone="aligned">
            Aligned to a company objective <strong>{alignedCount}</strong>
          </span>
          <span data-tone="unaligned">
            Unaligned <strong>{unalignedCount}</strong>
          </span>
        </AlignmentLegend>
      </AlignmentSummary>
    </AlignmentOverviewPanel>
  );
};
